import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/iconfont/iconfont.css'
import 'amfe-flexible' // 加载动态rem基准值
import './utils/dayjs'
// 引入vant组件
import Vant from 'vant'
// 引入vant的css样式
import '../node_modules/vant/lib/index.css'
// 加载全局样式
import './styles/index.less'
import moment from 'moment'
// 自动按需导入
import {
  NavBar,
  Field,
  Button,
  Form,
  Toast,
  CountDown,
  Tabbar,
  TabbarItem,
  Image as VanImage,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  Tab,
  Tabs,
  List,
  PullRefresh,
  Popup,
  Picker,
  DatetimePicker
} from 'vant'
Vue.config.productionTip = false
// 注册组件
Vue.use(Vant)

Vue.filter('dateFormat', (str, partten = 'YYYY-MM-DD') => {
  return moment(str).format(partten)
})
// 注册
Vue.use(NavBar)
Vue.use(Field)
Vue.use(Button)
Vue.use(Form)
Vue.use(Toast)
Vue.use(CountDown)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(VanImage)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(PullRefresh)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
